export { default as Act1 } from './Act1';
export { default as Act2 } from './Act2';
export { default as Act3 } from './Act3';